<template>
  <main class="marketing-automation-detail">
    <loading v-if="loading"
             class="marketing-automation-detail-loading" />

    <marketing-automation-form v-else
                               :automation="automation" />
  </main>
</template>

<script>
import EventBus from "@packages/event-bus";
import Loading from "@/components/generic/Loading.vue";
import MarketingAutomationForm from "@components/modules/marketing/automation/form/MarketingAutomationForm";

export default {
  components: {
    MarketingAutomationForm,
    Loading,
  },

  props: {},

  created() {
    this.$store.commit("SET_AUTOMATION_EDIT_NEEDS_SAVING", false);
    this.fetchAutomation();
  },

  data() {
    return {
      automation: undefined,
      loading: false,
    };
  },

  methods: {
    async fetchAutomation() {
      this.loading = true;

      const automationId = this.$route.params.automationId;

      const automation = await this.$api.marketing.automation.flow.get({
        automationId,
      });

      this.automation = automation;

      EventBus.$emit("SET_AUTOMATION_DETAIL_NAME", automation.name);

      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-automation-detail {
  .marketing-automation-detail-loading {
    margin: 30px auto;
    width: 30px;
    height: 30px;
  }
}
</style>
